import React, { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Highlight from 'react-highlight';
import Chart from 'chart.js/auto';
import { Card, CardHeader, CardHeaderBtn, CardImgOverlay, CardBody } from './../../components/card/card.jsx';
import { NavScrollTo } from './../../components/nav-scroll-to/nav-scroll-to.jsx';
import { Icon } from '@iconify/react';
import { getChartJsDefaultOptions } from './../../composables/chartOptions.js';

function Widgets() {
	const [code1, setCode1] = useState();
	const [code2, setCode2] = useState();
	const [code3, setCode3] = useState();
	const [code4, setCode4] = useState();
	const [code5, setCode5] = useState();
	const [code6, setCode6] = useState();
	const [code7, setCode7] = useState();
	const [code8, setCode8] = useState();
	const [code9, setCode9] = useState();
	const [code10, setCode10] = useState();
	const [code11, setCode11] = useState();
	var chart = '';
	
	function renderChart() {
		getChartJsDefaultOptions();
		
		var themeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		
		var chartContainer = document.getElementById('chartContainer');
		if (chart) {
			chart.destroy();
		}
		if (chartContainer) {
			chartContainer.innerHTML = '<canvas id="widgetBarChart" className="w-100 h-100"></canvas>';
			chart = new Chart(document.getElementById('widgetBarChart'), {
				type: 'line',
				data: {
					labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
					datasets: [{
						color: theme,
						backgroundColor: 'rgba('+ themeRgb +', .2)',
						borderColor:theme,
						borderWidth: 1.5,
						pointBackgroundColor: theme,
						pointBorderWidth: 1.5,
						pointRadius: 4,
						pointHoverBackgroundColor: theme,
						pointHoverBorderColor: theme,
						pointHoverRadius: 7,
						label: 'Total Sales',
						data: [12, 19, 4, 5, 2, 3]
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}
	}
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/widgets/widget-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-2.json').then(function(response) { return response.text(); }).then((html) => { setCode2(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-3.json').then(function(response) { return response.text(); }).then((html) => { setCode3(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-4.json').then(function(response) { return response.text(); }).then((html) => { setCode4(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-5.json').then(function(response) { return response.text(); }).then((html) => { setCode5(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-6.json').then(function(response) { return response.text(); }).then((html) => { setCode6(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-7.json').then(function(response) { return response.text(); }).then((html) => { setCode7(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-8.json').then(function(response) { return response.text(); }).then((html) => { setCode8(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-9.json').then(function(response) { return response.text(); }).then((html) => { setCode9(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-10.json').then(function(response) { return response.text(); }).then((html) => { setCode10(html); });
		fetch('/quantum-react/assets/data/widgets/widget-code-11.json').then(function(response) { return response.text(); }).then((html) => { setCode11(html); });
		
		renderChart();
		
		document.addEventListener('theme-reload', () => {
			renderChart();
		});
		// eslint-disable-next-line
	}, []);
	
	return (
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-xl-10">
					<div className="row">
						<div className="col-xl-9">
							<h1 className="page-header">
								Widgets <small>page header description goes here...</small>
							</h1>
							<hr className="mb-4 opacity-3" />
							
							<div id="cardWidget" className="mb-5">
								<h4>Card widget</h4>
								<p>Card widget is created by using existing Bootstrap <code>Card</code> component with <code>CardImgOverlay</code> and <code>.d-flex</code> utilities.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<img src="/quantum-react/assets/img/widget/cover-1.jpg" alt="" className="object-fit-cover h-250px" />
													<CardImgOverlay className="d-flex flex-column bg-black bg-opacity-50">
														<div className="flex-fill">
															<div className="d-flex align-items-center">
																<h6 className="m-0">Youtube</h6>
																<div className="dropdown ms-auto">
																	<a href="#/" className="text-white text-opacity-75" data-bs-toggle="dropdown"><i className="fa fa-ellipsis-h fa-lg"></i></a>
																	<div className="dropdown-menu dropdown-menu-end">
																		<a href="//www.youtube.com/watch?v=_AS5nu4u1ss" className="dropdown-item">View</a>
																	</div>
																</div>
															</div>
														</div>
														<div>
															<a href="//www.youtube.com/watch?v=_AS5nu4u1ss" data-lity className="text-white text-decoration-none d-flex align-items-center">
																<div className="bg-white bg-opacity-15 text-white w-40px h-40px d-flex align-items-center justify-content-center">
																	<Icon icon="material-symbols-light:play-arrow-outline" className="fs-36px" />
																</div>
																<div className="ms-3 flex-1">
																	<div className="fw-semibold">Tesla’s Revolutionary Electric Future</div>
																	<div className="small text-white text-opacity-50">
																		<i className="far fa-eye"></i> 1.58m views 
																		<i className="far fa-clock ms-3"></i> 39min ago
																	</div>
																</div>
															</a>
														</div>
													</CardImgOverlay>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code1}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="listWidget" className="mb-5">
								<h4>List widget</h4>
								<p>List widget is created by using existing Bootstrap <code>.list-group</code> component with <code>.d-flex</code> and droplet utilities css classes.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-6">
												<div className="text-body mb-2 fw-semibold">With icon</div>
												<div className="list-group mb-3">
													<div className="list-group-item d-flex align-items-center">
														<div className="w-35px h-35px fs-26px d-flex align-items-center justify-content-center bg-white bg-opacity-15 text-white">
															<Icon icon="material-symbols-light:home-app-logo" />
														</div>
														<div className="flex-fill px-3 py-1">
															<div className="fw-semibold">Apps Store</div>
															<div className="small text-body text-opacity-50">102 new download</div>
														</div>
														<div className="dropdown">
															<a href="#/" data-bs-toggle="dropdown" className="text-body text-opacity-50"><i className="fa fa-ellipsis-h"></i></a>
															<div className="dropdown-menu dropdown-menu-end">
																<a href="#/" className="dropdown-item">View</a>
																<a href="#/" className="dropdown-item">Analytics</a>
																<a href="#/" className="dropdown-item">Report</a>
															</div>
														</div>
													</div>
													<div className="list-group-item d-flex align-items-center">
														<div className="w-35px h-35px fs-26px d-flex align-items-center justify-content-center bg-white bg-opacity-15 text-white">
															<Icon icon="material-symbols-light:menu-book-outline-sharp" />
														</div>
														<div className="flex-fill px-3 py-1">
															<div className="fw-semibold">iBooks App</div>
															<div className="small text-body text-opacity-50">32 new download</div>
														</div>
														<div className="dropdown">
															<a href="#/" data-bs-toggle="dropdown" className="text-body text-opacity-50"><i className="fa fa-ellipsis-h"></i></a>
															<div className="dropdown-menu dropdown-menu-end">
																<a href="#/" className="dropdown-item">View</a>
																<a href="#/" className="dropdown-item">Analytics</a>
																<a href="#/" className="dropdown-item">Report</a>
															</div>
														</div>
													</div>
												</div>
												<div className="text-body mb-2 fw-semibold">With image</div>
												<div className="list-group mb-3">
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center text-body">
														<img src="/quantum-react/assets/img/user/user.jpg" alt="" className="w-35px h-35px object-fit-cover" />
														<div className="flex-fill ps-3">
															<div className="fw-semibold d-flex align-items-center">
																Isaiah Hughes <span className="fa fa-circle text-success fs-4px ms-2"></span>
															</div>
														</div>
													</a>
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center text-body">
														<img src="/quantum-react/assets/img/user/user-2.jpg" alt="" className="w-35px h-35px object-fit-cover" />
														<div className="flex-fill ps-3">
															<div className="fw-semibold d-flex align-items-center">
																Ryan Turner <span className="fa fa-circle text-body text-opacity-50 fs-4px ms-2"></span>
															</div>
														</div>
													</a>
												</div>
											</div>
											<div className="col-xl-6">
												<div className="text-body mb-2 fw-semibold">With settings</div>
												<div className="list-group">
													<div className="list-group-item d-flex align-items-center">
														<div className="flex-fill py-1">
															<div className="fw-semibold">Server auto backup</div>
															<div className="small text-body text-opacity-50">last backup since yesterday</div>
														</div>
														<div>
															<div className="form-check me-n1">
																<input type="checkbox" className="form-check-input" id="customSwitch1" defaultChecked />
																<label className="form-check-label" htmlFor="customSwitch1"></label>
															</div>
														</div>
													</div>
													<div className="list-group-item d-flex align-items-center">
														<div className="flex-fill py-1">
															<div className="fw-semibold">Analytics enabled</div>
															<div className="small text-body text-opacity-50">3,392 data collected</div>
														</div>
														<div>
															<div className="form-switch me-n1">
																<input type="checkbox" className="form-check-input" id="customSwitch2" />
																<label className="form-check-label" htmlFor="customSwitch2"></label>
															</div>
														</div>
													</div>
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center">
														<div className="flex-fill py-1">
															<div className="fw-semibold">Link with arrow</div>
														</div>
														<div>
															<i className="fa fa-chevron-right"></i>
														</div>
													</a>
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center">
														<div className="flex-fill py-1">
															<div className="fw-semibold">Link with arrow</div>
														</div>
														<div>
															<i className="fa fa-chevron-right"></i>
														</div>
													</a>
												</div>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code2}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="statsWidget" className="mb-5">
								<h4>Stats widget</h4>
								<p>States widget is created by using Bootstrap <code>Card</code> and <code>CardBody</code> component with <code>.d-flex</code> and <code>background-color</code> utilities.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<CardBody>
														<div className="mb-2 small text-white fw-semibold d-flex align-items-center">
															<div className="flex-fill">TOTAL ORDERS</div>
															<div>
																<a href="#/" data-bs-toggle="dropdown" className="text-white text-opacity-50"><i className="bi bi-three-dots-vertical fa-lg"></i></a>
																<div className="dropdown-menu dropdown-menu-end">
																	<a href="#/" className="dropdown-item">View full report</a>
																	<a href="#/" className="dropdown-item">Reload</a>
																	<a href="#/" className="dropdown-item">Export Data</a>
																</div>
															</div>
														</div>
														<div className="row mb-1">
															<div className="col-lg-12 position-relative">
																<h1 className="mb-1 d-flex align-items-center text-theme">
																	302
																	<span className="bg-white bg-opacity-15 badge fs-9px fw-semibold text-white px-2 py-2 d-flex align-items-center ms-3">
																		<i className="fa fa-exclamation-circle me-2 opacity-5"></i> 
																		3 pending orders
																	</span>
																</h1>
																<div className="small"><span className="badge bg-theme bg-opacity-15 text-theme py-2 me-1 fs-9px">+12%</span> compare to last week</div>
																<i className="fab fa-google-wallet display-3 lh-1 text-body text-opacity-20 me-3 position-absolute end-0 top-0"></i>
															</div>
														</div>
														<div className="mt-3 fs-9px fw-semibold text-body text-opacity-50">
															<div>LAST UPDATED ON:</div>
															<div className="text-body text-opacity-75">Feb 3, 4:09:57 AM UTC</div>
														</div>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code3}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="chartWidget" className="mb-5">
								<h4>Chart widget</h4>
								<p>Chart widget created by using Bootstrap <code>Card</code>, <code>CardHeader</code>, <code>CardHeaderBtn</code>, <code>CardBody</code> and <code>.list-group</code> component combined with Chart.js plugins.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<CardHeader className="with-btn">
														WEEKLY ANALYTICS
														<CardHeaderBtn />
													</CardHeader>
													<CardBody className="text-body text-center">
														<div className="h-150px w-100 d-block mb-n1">
															<div id="chartContainer"></div>
														</div>
													</CardBody>
													<CardBody className="d-flex align-items-center">
														<div className="w-35px h-35px bg-theme bg-opacity-15 text-theme d-flex align-items-center justify-content-center fs-30px">
															<Icon icon="material-symbols-light:frame-person-outline-sharp" />
														</div>
														<div className="flex-fill px-3 py-1">
															<div className="fw-semibold">Total Visitors</div>
															<div className="small text-body text-opacity-50">11 Mar - 18 Mar</div>
														</div>
														<div>
															<div className="fw-semibold h3 m-0">1.3m</div>
														</div>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code4}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="userListWidget" className="mb-5">
								<h4>User list widget</h4>
								<p>User list widget used to display people who participate in a project or a group.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="widget-user-list">
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-1.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-2.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-3.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-4.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-5.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-6.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link"><img src="/quantum-react/assets/img/user/user-7.jpg" alt="" /></a></div>
											<div className="widget-user-list-item"><a href="#/" className="widget-user-list-link bg-white bg-opacity-15 text-white fs-10px fw-semibold">+26</a></div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code5}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="mapWidget" className="mb-5">
								<h4>Map widget</h4>
								<p>Map widget created with Bootstrap <code>Card</code>, <code>CardHeader</code>, <code>CardHeaderBtn</code>, <code>CardBody</code> and <code>.list-group</code> component twitted with helper css classes.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<CardHeader className="with-btn">
														GOOGLE MAP
														<CardHeaderBtn />
													</CardHeader>
													<div>
														<div className="ratio ratio-21x9">
															<iframe title="Google" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d960.5886473867613!2d-122.41743634015282!3d37.776451983493104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809c6c8f4459%3A0xb10ed6d9b5050fa5!2sTwitter+HQ!5e0!3m2!1sen!2s!4v1495935122933" allowFullScreen></iframe>
														</div>
													</div>
													<CardBody className="d-flex align-items-center">
														<div className="w-30px h-30px d-flex text-white text-opacity-50 fs-20px bg-white bg-opacity-15 align-items-center justify-content-center">
															<Icon icon="material-symbols-light:map-outline-sharp" />
														</div>
														<div className="flex-fill px-3">
															<div className="fw-semibold text-white">via Road I-88E</div>
															<div className="small lh-sm">Fastest route, the usual traffic</div>
														</div>
														<div className="text-nowrap py-1">
															<div className="text-success fw-semibold">3h 54min</div>
															<div className="small lh-sm">393km</div>
														</div>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code6}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="chatWidget" className="mb-5">
								<h4>Chat widget</h4>
								<p>Chat widget created by using Bootstrap <code>Card</code>, <code>CardHeader</code>, <code>CardHeaderBtn</code> and <code>PerfectScrollbar</code> component with custom created bubble chat ui.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<CardHeader className="with-btn">
														DISCUSSION GROUP
														<CardHeaderBtn />
													</CardHeader>
													<PerfectScrollbar className="card-body h-200px">
														<div className="widget-chat">
															<div className="widget-chat-item">
																<div className="widget-chat-media"><img src="/quantum-react/assets/img/user/user-2.jpg" alt="" /></div>
																<div className="widget-chat-content">
																	<div className="widget-chat-name">Roberto Lambert</div>
																	<div className="widget-chat-message last">
																		Hey, I'm testing out group messaging.
																	</div>
																</div>
															</div>
															<div className="widget-chat-item reply">
																<div className="widget-chat-content">
																	<div className="widget-chat-message last">
																		Cool
																	</div>
																	<div className="widget-chat-status">Read 16:26</div>
																</div>
															</div>
															<div className="widget-chat-date">Today 14:21</div>
															<div className="widget-chat-item">
																<div className="widget-chat-media"><img src="/quantum-react/assets/img/user/user-3.jpg" alt="" /></div>
																<div className="widget-chat-content">
																	<div className="widget-chat-name">Rick Powell</div>
																	<div className="widget-chat-message last">
																		Awesome! What's new?
																	</div>
																</div>
															</div>
															<div className="widget-chat-item">
																<div className="widget-chat-media"><img src="/quantum-react/assets/img/user/user-2.jpg" alt="" /></div>
																<div className="widget-chat-content">
																	<div className="widget-chat-name">Roberto Lambert</div>
																	<div className="widget-chat-message">
																		Not much, It's got a new look, contact pics show up in group messaging, some other small stuff.
																	</div>
																	<div className="widget-chat-message last">
																		How's crusty old iOS 6 treating you?
																	</div>
																</div>
															</div>
															<div className="widget-chat-item reply">
																<div className="widget-chat-content">
																	<div className="widget-chat-message last">
																		Sucks
																	</div>
																	<div className="widget-chat-status">Read 16:30</div>
																</div>
															</div>
														</div>
													</PerfectScrollbar>
													<CardBody>
														<div className="input-group">
															<input type="text" className="form-control ps-3" placeholder="Write something..." />
															<button className="btn btn-theme w-70px" type="button">SEND</button>
														</div>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code7}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="profileWidget" className="mb-5">
								<h4>Profile widget</h4>
								<p>Profile widget created by using Bootstrap <code>Card</code>, <code>CardImgOverlay</code> and <code>CardBody</code> component with Bootstrap grid.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<div className="position-relative overflow-hidden h-160px">
														<img src="/quantum-react/assets/img/widget/cover-2.jpg" className="card-img-top" alt="" />
														<CardImgOverlay className="text-center text-white bg-black bg-opacity-50 backdrop-filter-3px d-flex align-items-center flex-column justify-content-center">
															<div className="my-3">
																<img src="/quantum-react/assets/img/user/user.jpg" alt="" className="h-80px" />
															</div>
															<div>
																<div className="fw-semibold text-white">Maurice Patterson</div>
																<div className="small text-white text-opacity-50">Never give up</div>
															</div>
														</CardImgOverlay>
													</div>
													<CardBody>
														<div className="row text-center">
															<div className="col-4">
																<div className="fw-semibold fs-5 text-white">415</div>
																<div className="fs-9px">POSTS</div>
															</div>
															<div className="col-4">
																<div className="fw-semibold fs-5 text-white">140k</div>
																<div className="fs-9px">FOLLOWERS</div>
															</div>
															<div className="col-4">
																<div className="fw-semibold fs-5 text-white">697</div>
																<div className="fs-9px">FOLLOWING</div>
															</div>
														</div>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code8}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="productWidget" className="mb-5">
								<h4>Product widget</h4>
								<p>Product widget created by using Bootstrap <code>.list-group</code> component with <code>.d-flex</code> utilities.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<div className="list-group">
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center text-body">
														<div className="w-45px h-45px d-flex align-items-center justify-content-center bg-white p-2">
															<img src="/quantum-react/assets/img/product/product-1.jpg" alt="" className="mw-100 mh-100" />
														</div>
														<div className="flex-fill px-3">
															<div className="fw-semibold fs-11px">iPhone 14 Pro Max</div>
															<div className="fw-semibold fs-9px text-white text-opacity-50">PHONE</div>
															<div className="d-flex align-items-center fs-9px">
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-outline-sharp" className="text-theme fs-11px me-2" />
																<div className="pt-1px">(128)</div>
															</div>
														</div>
														<div>
															<span className="badge text-white bg-white bg-opacity-15 fs-10px py-2 px-2 fw-semibold d-block">
																$999.00
															</span>
														</div>
													</a>
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center text-body">
														<div className="w-45px h-45px d-flex align-items-center justify-content-center bg-white p-2">
															<img src="/quantum-react/assets/img/product/product-2.jpg" alt="" className="mw-100 mh-100" />
														</div>
														<div className="flex-fill px-3 py-1">
															<div className="fw-semibold fs-11px">MacBook Pro</div>
															<div className="fw-semibold fs-9px text-white text-opacity-50">LAPTOP</div>
															<div className="d-flex align-items-center fs-9px">
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-outline-sharp" className="text-theme fs-11px me-2" />
																<div className="pt-1px">(93)</div>
															</div>
														</div>
														<div>
															<span className="badge text-white bg-white bg-opacity-15 fs-10px py-2 px-2 fw-semibold d-block">
																$599.00
															</span>
														</div>
													</a>
													<a href="#/" className="list-group-item list-group-item-action d-flex align-items-center text-body">
														<div className="w-45px h-45px d-flex align-items-center justify-content-center bg-white p-2">
															<img src="/quantum-react/assets/img/product/product-3.jpg" alt="" className="mw-100 mh-100" />
														</div>
														<div className="flex-fill px-3 py-1">
															<div className="fw-semibold fs-11px">Apple Watch Series 9</div>
															<div className="fw-semibold fs-9px text-white text-opacity-50">WATCH</div>
															<div className="d-flex align-items-center fs-9px">
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-sharp" className="text-theme fs-11px" />
																<Icon icon="material-symbols-light:kid-star-outline-sharp" className="text-theme fs-11px me-2" />
																<div className="pt-1px">(41)</div>
															</div>
														</div>
														<div>
															<span className="badge text-white bg-white bg-opacity-15 fs-10px py-2 px-2 fw-semibold d-block">
																$399.00
															</span>
														</div>
													</a>
												</div>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code9}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="reminderWidget" className="mb-5">
								<h4>Reminder widget</h4>
								<p>Reminder widget used to create a simple calendar to notify the user upcoming events or task.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<CardHeader>TODAY, NOV 4</CardHeader>
													<CardBody className="p-0 widget-reminder">
														<div className="widget-reminder-item">
															<div className="widget-reminder-time">09:00<br />12:00</div>
															<div className="widget-reminder-divider bg-success"></div>
															<div className="widget-reminder-content">
																<div className="fw-semibold text-white">Meeting with HR</div>
																<div> - Conference Room</div>
															</div>
														</div>
														<div className="widget-reminder-item">
															<div className="widget-reminder-time">20:00<br />23:00</div>
															<div className="widget-reminder-divider bg-primary"></div>
															<div className="widget-reminder-content">
																<div className="fw-semibold text-white">Dinner with Richard</div>
																<div> - Tom's Too Restaurant</div>
																<div className="d-flex align-items-center mt-2">
																	<div className="flex-fill d-flex align-items-center">
																		<img src="/quantum-react/assets/img/user/user-3.jpg" alt="" width="16" className="me-2" /> Richard Leong
																	</div>
																	<a href="#/" className="ms-auto">Contact</a>
																</div>
															</div>
														</div>
													</CardBody>
													<CardHeader>TOMORROW, NOV 5</CardHeader>
													<CardBody className="p-0 widget-reminder">
														<div className="widget-reminder-item">
															<div className="widget-reminder-time">All day</div>
															<div className="widget-reminder-divider bg-gray-300"></div>
															<div className="widget-reminder-content">
																<div className="fw-semibold text-white">Terry Birthday</div>
															</div>
														</div>
														<div className="widget-reminder-item">
															<div className="widget-reminder-time">08:00</div>
															<div className="widget-reminder-divider bg-gray-300"></div>
															<div className="widget-reminder-content">
																<div className="fw-semibold text-white">Meeting</div>
															</div>
														</div>
														<div className="widget-reminder-item">
															<div className="widget-reminder-time">00:00<br />00:30</div>
															<div className="widget-reminder-divider bg-gray-300"></div>
															<div className="widget-reminder-content">
																<div className="fw-semibold text-white">Server Maintenance</div>
																<div> - Data Centre</div>
															</div>
														</div>
													</CardBody>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code10}</Highlight>
									</div>
								</Card>
							</div>
							
							<div id="imageListWidget" className="mb-5">
								<h4>Image list widget</h4>
								<p>Image list widget created by using Bootstrap <code>.card</code> and <code>.list-group</code> component with <code>.d-flex</code> utilities.</p>
								<Card>
									<CardHeader className="with-btn">
										INSTALLATION
										<CardHeaderBtn />
									</CardHeader>
									<CardBody>
										<div className="row">
											<div className="col-xl-8">
												<Card>
													<CardBody>
														<a href="#/" className="d-flex align-items-center text-body text-decoration-none fs-12px">
															<div className="flex-fill pe-3">
																<div className="fw-semibold">Library (20)</div>
																<div className="fs-10px text-white text-opacity-50">3,192 Image Found</div>
															</div>
															<div>
																<i className="fa fa-chevron-right fa-lg text-body text-opacity-50"></i>
															</div>
														</a>
													</CardBody>
													<div className="widget-img-list mt-1px">
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-1.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-1.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-2.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-2.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-3.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-3.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-4.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-4.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-5.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-5.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-21.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-21.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-22.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-22.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-23.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-23.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-24.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-24.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-25.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-25.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-26.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-26.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-27.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-27.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-28.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-28.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-29.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-29.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-30.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-30.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-31.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-31.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-32.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-32.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-33.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-33.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-34.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-34.jpg)' }}></span></a></div>
														<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-35.jpg" data-lity><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-35.jpg)' }}></span></a></div>
													</div>
												</Card>
											</div>
										</div>
									</CardBody>
									<div className="hljs-container">
										<Highlight className='html'>{code11}</Highlight>
									</div>
								</Card>
							</div>
						</div>
						
						<div className="col-xl-3">
							<NavScrollTo>
								<nav className="nav">
									<a className="nav-link" href="#cardWidget" data-toggle="scroll-to">Card widget</a>
									<a className="nav-link" href="#listWidget" data-toggle="scroll-to">List widget</a>
									<a className="nav-link" href="#statsWidget" data-toggle="scroll-to">Stats widget</a>
									<a className="nav-link" href="#chartWidget" data-toggle="scroll-to">Chart widget</a>
									<a className="nav-link" href="#userListWidget" data-toggle="scroll-to">User list widget</a>
									<a className="nav-link" href="#mapWidget" data-toggle="scroll-to">Map widget</a>
									<a className="nav-link" href="#chatWidget" data-toggle="scroll-to">Chat widget</a>
									<a className="nav-link" href="#profileWidget" data-toggle="scroll-to">Profile widget</a>
									<a className="nav-link" href="#productWidget" data-toggle="scroll-to">Product widget</a>
									<a className="nav-link" href="#reminderWidget" data-toggle="scroll-to">Reminder widget</a>
									<a className="nav-link" href="#imageListWidget" data-toggle="scroll-to">Image list widget</a>
								</nav>
							</NavScrollTo>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Widgets;